// BundleCard component - extends Bundles class
if (!customElements.get('bundle-card-product')) {
  class BundleCard extends HTMLElement {
    constructor() {
      super();
      
      // Create an instance of the Bundles class to access its methods
      this.bundles = new Bundles();
      this.displayBundleContainer = false;
      console.log('BundleCard component initialized');
    }

    async init() {
      console.log('BundleCard component initialized');
    }

    addEventListeners() {
      const addToCartBtn = this.bundles.container.querySelector('.js--add-to-cart-bundle');
      if (!addToCartBtn) {
        console.warn('No add-to-cart buttons found');
        return;
      }

      if (!this.bundleId) {
        console.warn('No bundle ID found');
        return;
      }

      addToCartBtn.addEventListener('click', async (event) => {
        event.preventDefault();
        console.log('Add to cart button clicked');
        await this.bundles.addItemsToShopify(this.bundleId);
        await this.bundles.getShopifyCart();
        await this.bundles.createCartBundle(this.bundleId);
      });
    }

    hideCardBundleContainer() {
      let parent = null;

      if (this.template === 'collection') {
        parent = this.closest('.collection__products-grid-item');
      } else if (this.template === 'search') {
        parent = this.closest('li.grid__item');
      }

      if (!parent) return;

      parent.classList.add('bundle-card--hide');
    }

    async connectedCallback() { 
      // Initialize the bundles instance with this element
      this.bundles.initializeFromElement(this);
      this.template = this.getAttribute('data-template') || '';
      this.bundles.bundleData = await this.bundles.getBundleAsProduct();
      this.bundleId = this.bundles.bundleData[0]?.id || null;
      console.log("this bundle data:", this.bundles.bundleData);
      this.bundles.productData = await this.bundles.getShopifyProductsData();

      console.log('Product data:', this.bundles.productData);

      for(const bundle of this.bundles.bundleData) {
        const isBundleRestricted = await this.bundles.getIsBundleRestricted(bundle.id);
        if (isBundleRestricted) {
          console.warn(`Bundle ${bundle.id} contains restricted products. Skipping rendering.`);
          continue;
        }

        const isBundleOOS = await this.bundles.getIsBundleOOS(bundle.id);
        if (isBundleOOS) {
          console.warn(`Bundle ${bundle.id} is out of stock. Skipping rendering.`);
          continue;
        }

        const getIsBundleTSCRestricted = await this.bundles.getIsBundleTSCRestricted(bundle.id);
        if (getIsBundleTSCRestricted) {
          console.warn(`Bundle ${bundle.id} contains TSC restricted products. Skipping rendering.`);
          continue;
        }

        this.bundles.getShopifyCart();
        this.bundles.createAddToCartobjects(bundle);
        this.bundles.renderPrice(bundle.id);
        this.bundles.renderDCE(bundle.id);
        this.bundles.renderThcPotencyGauge(bundle.id);
        this.bundles.renderCbdPotencyGauge(bundle.id);
        this.bundles.renderCannabinoidClassification(bundle.id);
        this.bundles.renderPlantType(bundle.id);

        if (!this.displayBundleContainer) {
          this.displayBundleContainer = true;
        }

        this.classList.remove('bundle-card--hide');
      }

      if (this.displayBundleContainer) {
        this.addEventListeners();
      } else {
        this.hideCardBundleContainer();
      }
    }

    disconnectedCallback() {
      this.bundles.disconnectedCallback();
    }
  }

  customElements.define('bundle-card-product', BundleCard);
}